import { useLocation } from "react-router-dom";

import { Link } from "@/components/ui/Link";
import { Button } from "@/components/ui-deprecated/Button";
import { Container, Content, IconStyled, PageStyled, Title } from "@/pages/errors/ErrorPage.styles";

const NotFoundPage = () => {
    const { pathname } = useLocation();

    return (
        <PageStyled>
            <Container>
                <Title>
                    <IconStyled icon={"info-circle"} />
                    Page not found
                </Title>
                <Content>
                    The URL (address, link or bookmark) you are using may no longer be valid - <code>{pathname}</code>.
                    <br />
                    You can start over on the Dashboard.
                </Content>
                <Link to={"/"}>
                    <Button>Navigate to Dashboard</Button>
                </Link>
            </Container>
        </PageStyled>
    );
};

export { NotFoundPage };
